module.exports = "<span class=\"btn {{btnVariant}} {{btnSize}} {{btnBlock}} {{inactive ? 'btn-inactive' : ''}} {{btnDisabled}}\" v-on:click.stop.prevent=\"changeLocation($router, link)\">\n\t<slot></slot>\n</span>";


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/buttons.html
// module id = 15
// module chunks = 0